import React from 'react';
import { storyblokEditable } from '@storyblok/react';
import Avatar from '@mui/material/Avatar';
import { useStoryblok } from '@storyblok/react';
// import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
import { useParams } from 'react-router-dom';
import { formatDate, imageUrl } from '../../utils';
import { Typography } from '@mui/material';
import GapAround from '../../components/hoc/GapAround';
// import { MarkdownRenderer } from '../../components/blog/Markdown';
import Loader from '../../components/common/Loader';
import useSSR from 'use-ssr';
import { useState, useEffect } from 'react';
// import { marked } from 'marked';
import MarkdownRenderer from '../../components/common/MarkdownRenderer';

interface Props {}

function BlogArticle(props: Props) {
  const {} = props;
  let { slug } = useParams();
  const story = useStoryblok(`blogs/${slug}`, { version: 'draft' });
  const { content, created_at }: any = story;
  const { isBrowser } = useSSR();
  useEffect(() => {
    if (isBrowser) {
      import('react-markdown').then((markdown) => {});
    }
  }, []);
  // const htmlContent = marked(content?.divider || '');
  const subheaderClass = {
    fontFamily: 'var(--fontBase)',
    fontSize: '1rem',
    fontWeight: 'bold',
    marginBottom: '5px',
  };

  const contentClass = {
    fontFamily: 'var(--fontBase)',
    fontSize: '1.2rem',
    lineHeight: '1.8rem',
    color: '#313b3f',
  };
  
  const whiteLogo = imageUrl('atini-logo-white.svg');

  return (
    <GapAround spaceTaken={3} childrenClasses="h-full mb-10 breakone:mb-0 md:mx-10">
        <div className='relative min-h-[400px]'>
            {story.content && (
      <div className="h-full w-full editor flex items-center flex-col" {...storyblokEditable(story.content)}>
        <div className="mb-10" style={{ justifySelf: 'center' }}>
          <Typography
            variant="h1"
            sx={{
                fontFamily: 'var(--fontPrimary)',
                fontSize: {
                  xs: '1.5rem !important',
                  sm: '2rem !important',
                  md: '2.5rem !important',
                  lg: '3rem !important',
                },
              }}>
            {content?.title}
          </Typography>
          <div className="my-5">
            <MarkdownRenderer markdownText={content?.divider || ''} />
          </div>
          {/* <ReactMarkdown className="my-5" remarkPlugins={[remarkGfm]}>
            {content?.divider}
          </ReactMarkdown> */}
          {content?.title && (
            <div className="flex items-center gap-5">
            <Avatar
                alt="author"
                src={whiteLogo}
                sx={{
                  width: 55,
                  height: 55,
                  backgroundColor: '#5A9E95',
                  padding: "11px",
                }}
                slotProps={{ img: { style: { objectFit: 'contain' } } }}
              />
              <div>
                <Typography variant="h4" style={subheaderClass}>
                  {content?.author}
                </Typography>
                <Typography variant="h4" style={{ ...subheaderClass, color: '#B0B0B0' }}>
                  {formatDate(created_at || null)}
                </Typography>
              </div>
            </div>
          )}
        </div>
        <img className="mb-10" style={{ maxWidth: '1040px', width: '100%' }} src={content?.articleImage?.filename} alt="" />
        <div className="w-full">
          <div style={contentClass}>
            <MarkdownRenderer markdownText={content?.content || ''} />
            {/* <MarkdownRenderer>{content?.content}</MarkdownRenderer> */}
          </div>
        </div>
      </div>
      )}
      {!story.content && (
        <div className="w-full absolute left-[0] top-[0] h-full flex items-center justify-center">
          <Loader size={75} />
        </div>
      )}
      </div>
    </GapAround>
  );
}

export default BlogArticle;
